import React from 'react'
import DatePicker from '../DatePicker'
import Text from '../Text'
import ProceedButton from './ProceedButton'
import { useEffect } from 'react'

const DateOfBirth = ({
  onChange,
  name,
  value,
  onMoveNext,
  isLastStep,
  loading = false,
  title,
  subtitle,
}) => {
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = ''
    }
  }, [])
  return (
    <div className="pt-12 px-4 overflow-y-hidden">
      <div className="space-y-3 pb-1">
        <Text
          tag="h2"
          variant="display"
          size="small"
          className="text-[#101828]"
        >
          {title || 'What is your date of birth?'}
        </Text>
        <Text tag="p" variant="body" size="medium" className="text-[#475467]">
          {subtitle ||
            ` We ask your DOB to personalise your nutritional care based on your
          age.`}
        </Text>
      </div>

      <div className="mt-3">
        <DatePicker onChange={onChange} name={name} value={value} />
      </div>

      <ProceedButton
        onMoveNext={onMoveNext}
        isLastStep={isLastStep}
        disabled={!value || loading}
        loading={loading}
      />
    </div>
  )
}

export default DateOfBirth
